export const REMOVE_SNACKBAR = 'REMOVE_SNACKBAR';

export const removeSnackbar = key => ({
  type: REMOVE_SNACKBAR,
  key,
});
